import React, { ReactNode, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import "./AppLayout.css";

import Sidebar from "./Sidebar";
import TopHeader from "./TopHeader";
import { PageHeaderContext, PageHeaderState } from "./PageHeaderContext";

interface AppLayoutProps {
  children: ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  const location = useLocation();
  const [pageHeader, setPageHeader] = useState<PageHeaderState | null>(null);
  const pageHeaderContextValue = useMemo(
    () => ({ pageHeader, setPageHeader }),
    [pageHeader],
  );
  const isPublicEntryPage =
    location.pathname === "/register" ||
    location.pathname === "/set-password" ||
    location.pathname.startsWith("/profile/") ||
    location.pathname.startsWith("/rota-response/");

  if (isPublicEntryPage) {
    return (
      <PageHeaderContext.Provider value={pageHeaderContextValue}>
        <main className="app-layout-content">{children}</main>
      </PageHeaderContext.Provider>
    );
  }

  return (
    <PageHeaderContext.Provider value={pageHeaderContextValue}>
      <div className="app-layout">
        <Sidebar />
        <div className="main-layout">
          <TopHeader />
          <main className="app-layout-content">{children}</main>
        </div>
      </div>
    </PageHeaderContext.Provider>
  );
}
